/**
 * @generated SignedSource<<b50475169bd07c41235d1bf8b22feb74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WTCSSelectTasksQuery$variables = {
  routineId: string;
};
export type WTCSSelectTasksQuery$data = {
  readonly routine: {
    readonly activeVersion: {
      readonly sections: ReadonlyArray<{
        readonly id: string;
        readonly section: {
          readonly id: string;
          readonly title: string | null;
        };
        readonly tasks: ReadonlyArray<{
          readonly __typename: string;
          readonly id: string;
          readonly title: string;
          readonly " $fragmentSpreads": FragmentRefs<"TaskListItemIcon_Task" | "TaskListItemTitle_Task">;
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion">;
      }>;
    };
    readonly id: string;
    readonly title: string;
  } | null;
};
export type WTCSSelectTasksQuery = {
  response: WTCSSelectTasksQuery$data;
  variables: WTCSSelectTasksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WTCSSelectTasksQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineVersion",
            "kind": "LinkedField",
            "name": "activeVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSectionVersion",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "tasks",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TaskListItemIcon_Task"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "TaskListItemTitle_Task"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WTCSSelectTasksQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineVersion",
            "kind": "LinkedField",
            "name": "activeVersion",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSectionVersion",
                "kind": "LinkedField",
                "name": "sections",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeam",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "icon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPrivate",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "tasks",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isTask"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unit",
                            "storageKey": null
                          }
                        ],
                        "type": "TaskNumber",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sentiments",
                            "storageKey": null
                          }
                        ],
                        "type": "TaskCheck",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3ef91e55d075667e200b385d06df6da0",
    "id": null,
    "metadata": {},
    "name": "WTCSSelectTasksQuery",
    "operationKind": "query",
    "text": "query WTCSSelectTasksQuery(\n  $routineId: ID!\n) {\n  routine(id: $routineId) {\n    id\n    title\n    activeVersion {\n      sections {\n        id\n        ...RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion\n        section {\n          id\n          title\n        }\n        tasks {\n          id\n          title\n          __typename\n          ...TaskListItemIcon_Task\n          ...TaskListItemTitle_Task\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment RoutineSectionVersionSectionHeaderContent_RoutineSectionVersion on RoutineSectionVersion {\n  id\n  title\n  section {\n    id\n    assignedTeam {\n      name\n      ...TeamIconCircleComponent_Team\n      id\n    }\n  }\n}\n\nfragment TaskListItemIcon_Task on Task {\n  __isTask: __typename\n  __typename\n  ... on TaskNumber {\n    unit\n  }\n  ... on TaskCheck {\n    sentiments\n  }\n  ... on TaskText {\n    __typename\n  }\n}\n\nfragment TaskListItemTitle_Task on Task {\n  __isTask: __typename\n  title\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n"
  }
};
})();

(node as any).hash = "df4a550328e3bc9892463b68da5e6288";

export default node;
